// Opens the real "Live Chat" widget (Layout/chatModal.jsx + chatMobile.jsx),
// which is already mounted on every admin page via Layout/Admin_Dashboard/header.jsx,
// pre-targeted at a given contact. Any page can call this instead of building
// its own chat UI — see header.jsx's "open-admin-chat" window event listener.
//
// user: the person to open a conversation with. Only user_id is required for
// the socket protocol (join_room/get_messages/send_message all key off it);
// name/email are just for display, and user_type controls the "Admin" vs
// "Support Team" label — pass "supplier" (or omit) for a normal contact.
export function openAdminChat(user) {
  if (!user || !user.user_id) {
    console.warn("openAdminChat: a user_id is required", user);
    return;
  }

  window.dispatchEvent(
    new CustomEvent("open-admin-chat", {
      detail: {
        user_id: user.user_id,
        name: user.name || "User",
        email: user.email || "",
        user_type: user.user_type || "supplier",
      },
    })
  );
}
